import angular from 'angular';
import moment from 'moment';
import { MeurhEscalaColaboradoresFormModalService } from '../form/colaboradores/modal/colaboradores.modal.service';
import { ModalConfirmService } from '../../../../shared/components/modal-confirm/modal.confirm.service';
import { FolgasService } from '../../../Folgas/folgas.service';
import { MeurhMudancasTrabalhadoresService } from '../../../MudancasTrabalhadores/mudancas-trabalhadores.service';
import { ListagemService } from '../../../../shared/services/listagem.service';
import { ConfiguracoesService } from '../../../Configuracoes/configuracoes.service';
import { MudancasTrabalhadoresTipoEnum } from '../../../MudancasTrabalhadores/enums/mudancas-trabalhadores.enum';
import { Empresa, Estabelecimento } from '../../../../core/usuario/models/usuario-model';
import { IExcluirEscalaForm } from '../models/escala.delete.model';
import { IConfiguracoesEscala, getConfiguracoesEscalaPadrao } from '../models/escala.configuracoes.model';
import { carregarConfiguracoesEscala, formatarDataFechamentoCalendario } from '../helpers/configuracoes-escala';

export class MeurhEscalaExcluirController {

    static $inject = [
        '$scope',
        '$rootScope',
        '$state',
        'MeurhEscalaColaboradoresFormModalService',
        'ModalConfirmService',
        'FolgasService',
        'MeurhMudancasTrabalhadoresService',
        'ListagemService',
        'ConfiguracoesService',
        'NewToaster'
    ];
    public form: angular.IFormController;
    public entity = <IExcluirEscalaForm> {
        empresa: this.$rootScope.session.entities.empresa.empresa,
        estabelecimento: this.$rootScope.session.entities.estabelecimento.estabelecimento,
        colaboradores: []
    };
    public saveResponse: { statusOk: boolean, message: string | null }[] = [];
    public busy: boolean = false;
    public busySave = {
        folga: false,
        lotacao: false,
        horario: false
    };

    public filtros = {
        empresa: this.$rootScope.session.entities.empresa.empresa,
        estabelecimento: this.$rootScope.session.entities.estabelecimento.estabelecimento,
    };
    public empresas: Empresa[];
    public estabelecimentos: Estabelecimento[];
    public listagemPermissao: string[] = ['visualizar_calendario'];
    public configuracoesEscala: IConfiguracoesEscala = getConfiguracoesEscalaPadrao();
    public permissaoGrupoEmpresarial = this.$rootScope.temPermissaoGrupoEmpresarial(
        this.listagemPermissao,
        this.$rootScope.nsjGlobals.a.grupoempresarial
    );
    public dataFechamentoCalendario = '';

    constructor (
        public $scope: angular.IScope,
        public $rootScope: angular.IRootScopeService & {
            liberadoTela: (arg: string) => boolean,
            temPermissao: (arg: string) => boolean,
            temPermissaoGrupoEmpresarial: (permissoes: string[], grupo: string) => boolean,
            session: any,
            nsjGlobals: any
        },
        public $state: angular.ui.IStateService,
        public ColaboradoresModalService: MeurhEscalaColaboradoresFormModalService,
        public ModalConfirmService: ModalConfirmService,
        public FolgasService: FolgasService,
        public MeurhMudancasTrabalhadoresService: MeurhMudancasTrabalhadoresService,
        public ListagemService: ListagemService,
        public ConfiguracoesService: ConfiguracoesService,
        public NewToaster: { pop: Function },
    ) {
        if (
            !this.$rootScope.temPermissao('visualizar_calendario') ||
            !this.$rootScope.liberadoTela('LIBERAR_CALENDARIO') ||
            !this.$rootScope.liberadoTela('LIBERAR_ADICIONAR_ESCALA') ||
            !(
                this.$rootScope.liberadoTela('LIBERAR_CALENDARIO_FOLGA') ||
                this.$rootScope.liberadoTela('LIBERAR_CALENDARIO_LOTACAO') ||
                this.$rootScope.liberadoTela('LIBERAR_CALENDARIO_HORARIO')
            )
        ) {
            $state.go('dp');
        }

        this.montaListagemVisibilidade();
        this.carregaConfiguracoesEscala();
        this.onResponseSuccess();
        this.onResponseError();

        this.$scope.$watchGroup([
            'mrh_scl_dlt_cntrllr.busySave.folga',
            'mrh_scl_dlt_cntrllr.busySave.lotacao',
            'mrh_scl_dlt_cntrllr.busySave.horario',
        ], (newValues: boolean[], oldValues: boolean[]) => {
            if (newValues !== oldValues && (newValues.every((busy) => busy === false))) {
                this.busy = false;
            }
        });

        this.$scope.$on('escala_delete_request_show_toast', (event, args: boolean, message: string | null) => {
            this.saveResponse.push({
                statusOk: args,
                message
            });
            if (Object.values(this.busySave).every((busy) => busy === false)) {
                if (this.saveResponse.every(response => response.statusOk === true)) {
                    this.NewToaster.pop({
                        type: 'success',
                        title: 'A escala foi excluída com sucesso!'
                    });
                    this.$state.go('meurh_escala');
                } else if (this.saveResponse.every(response => response.statusOk === false)) {
                    this.NewToaster.pop({
                        type: 'error',
                        title: 'Ocorreu um erro ao excluir a escala!',
                        body: this.setErrorMessage(this.saveResponse),
                        bodyOutputType: 'trustedHtml',
                        timeout: 8000,
                    });
                } else {
                    this.NewToaster.pop({
                        type: 'warning',
                        title: 'A escala foi parcialmente excluída!',
                        body: this.setErrorMessage(this.saveResponse),
                        bodyOutputType: 'trustedHtml',
                        timeout: 8000,
                    });
                }
            }
        });
    }

    montaListagemVisibilidade(): void {
        this.empresas = this.ListagemService.montaEmpresas(this.$rootScope.nsjGlobals.a.grupoempresarial, this.listagemPermissao);
        this.estabelecimentos = this.ListagemService.montaEstabelecimentos(this.filtros.empresa, this.empresas, this.listagemPermissao);
    }

    mudaEstabelecimentos(): void {
        this.estabelecimentos = this.filtros.empresa ? this.ListagemService.montaEstabelecimentos(this.filtros.empresa, this.empresas, this.listagemPermissao) : [];
        this.filtros.estabelecimento = this.estabelecimentos.length ? this.estabelecimentos[0].id : '';
        this.filtraEmpresaEstabelecimento();
    }

    filtraEmpresaEstabelecimento(): void {
        this.entity = <IExcluirEscalaForm> {
            empresa: this.filtros.empresa,
            estabelecimento: this.filtros.estabelecimento,
            colaboradores: []
        };
    }

    salvar() {
        this.form.$submitted = true;
        if (this.form.$invalid) {
            return;
        }
        let confirm = this.modal();
        confirm.result.then(() => {
            this.busy = true;
            this.saveResponse = [];
            if (this.entity.selecionados.folga) {
                this.busySave.folga = true;
                this.FolgasService.excluirEscala(this.setFolgaPayload());
            }
            if (this.entity.selecionados.lotacao) {
                this.busySave.lotacao = true;
                this.MeurhMudancasTrabalhadoresService.excluirEscala(
                    this.setMudancaPayload(MudancasTrabalhadoresTipoEnum.LOTACAO),
                    MudancasTrabalhadoresTipoEnum.LOTACAO
                );
            }
            if (this.entity.selecionados.horario) {
                this.busySave.horario = true;
                this.MeurhMudancasTrabalhadoresService.excluirEscala(
                    this.setMudancaPayload(MudancasTrabalhadoresTipoEnum.HORARIO),
                    MudancasTrabalhadoresTipoEnum.HORARIO
                );
            }
        }).catch(() => {/**/});
    }

    private carregaConfiguracoesEscala() {
        this.busy = true;

        carregarConfiguracoesEscala(this.ConfiguracoesService)
            .then((configuracoesEscala) => {
                this.configuracoesEscala = configuracoesEscala;
                this.dataFechamentoCalendario = formatarDataFechamentoCalendario(configuracoesEscala);
            })
            .finally(() => {
                this.busy = false;
                this.$scope.$applyAsync();
            });
    }

    private modal() {
        return this.ModalConfirmService.open(this.entity, 'Excluir escala', false, {
            title: 'Excluir escala',
            confirmText: 'Tem certeza que deseja excluir esta escala?',
            closeButton: 'Cancelar',
            closeButtonIcon: 'invisible',
            confirmButton: 'Excluir',
            confirmButtonIcon: 'invisible',
        });
    }

    private setFolgaPayload() {
        return {
            empresa: this.entity.empresa,
            estabelecimento: this.entity.estabelecimento,
            datainicial : this.entity.datainicial,
            datafinal : this.entity.datafinal,
            trabalhadores: this.entity.colaboradores,
        };
    }

    private setMudancaPayload(tipo: number) {
        return {
            empresa: this.entity.empresa,
            estabelecimento: this.entity.estabelecimento,
            datainicial: this.entity.datainicial,
            datafinal: this.entity.datafinal,
            trabalhadores: this.entity.colaboradores,
            tipo,
        };
    }

    private onResponseSuccess(): void {
        this.$scope.$on('folgas_exclusao_escala_submitted', (event, args) => {
            this.busySave.folga = false;
            this.responseSuccess('folga');
        });
        this.$scope.$on('mudancastrabalhadores_exclusao_escala_submitted', (event, args, tipo) =>  {
            tipo === MudancasTrabalhadoresTipoEnum.LOTACAO ? this.busySave.lotacao = false : this.busySave.horario = false;
            this.responseSuccess(tipo === MudancasTrabalhadoresTipoEnum.LOTACAO ? 'lotacao' : 'horario');
        });
    }

    private responseSuccess(tipo: string): void {
        this.entity.selecionados[tipo] = false;
        this.$scope.$broadcast('escala_delete_request_show_toast', true, null);
    }

    private onResponseError(): void {
        this.$scope.$on('folgas_exclusao_escala_submit_error', (event, args) => {
            this.busySave.folga = false;
            this.responseError(event, args, 'folga');
        });
        this.$scope.$on('mudancastrabalhadores_exclusao_escala_submit_error', (event, args, tipo) => {
            tipo === MudancasTrabalhadoresTipoEnum.LOTACAO ? this.busySave.lotacao = false : this.busySave.horario = false;
            this.responseError(event, args, tipo === MudancasTrabalhadoresTipoEnum.LOTACAO ? 'lotação' : 'horário');
        });
    }

    private responseError(event: angular.IAngularEvent, args: any, tipo?: string | number): void {
        let message = '';
        if (args.data && args.data.length && tipo === 'folga') {
            let childrenMsg = '';
            args.data.forEach((erro: any) => {
                childrenMsg += `
                    <li>
                        ${erro.trabalhador.nome} - ${moment(new Date(erro.datafolga)).format('DD/MM/YYYY')} - ${erro.erro}
                    </li>
                `;
            });
            message = '<ul>' + childrenMsg + '</ul>';
        }

        if (message === '') {
            message = `<ul><li>Ocorreu um erro ao excluir a escala de ${tipo}</li></ul>`;
        }
        this.$scope.$broadcast('escala_delete_request_show_toast', false, message);
        this.form.$submitted = false;
    }

    private setErrorMessage(saveResponse: { statusOk: boolean, message: string | null }[]): string {
        let msg = '';
        saveResponse.forEach(response => {
            if (!response.statusOk) {
                msg += response.message;
            }
        });
        return msg;
    }
}
